// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 538) return "static/chunks/538-7bbc6599108194d2.js";
	if (chunkId === 555) return "static/chunks/555-e5a9a00a7c5cca9c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"6172bac3ceb5f6e1","205":"4cc40c0e1f4cb0f2","319":"0cbc2894a3f1b950","340":"ff528ff62f38f56f","367":"947426639a6f4276","639":"a322f5d778fbd249","748":"8c4d4469dd75bd32"}[chunkId] + ".js";
};